import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from './base.service';
import {Observable} from 'rxjs';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {AppUrl} from '../constants/app-url';

@Injectable({
    providedIn: 'root'
})
export class BranchService extends BaseService {
    constructor(public http: HttpClient,
                public alertService: AlertService,
                public globalService: GlobalService) {
        super(http, alertService, globalService);
    }

    get(data): Observable<any> {
        return this.getRequest(AppUrl.BRANCHES(), data);
    }

    count(): Observable<any> {
        return this.getRequest(AppUrl.ALL_BRANCHES_COUNT());
    }

    detail(id): Observable<any> {
        return this.getRequest(AppUrl.BRANCHES(id));
    }

    create(data): Observable<any> {
        return this.postRequest(AppUrl.BRANCHES(), data);
    }

    update(id, data): Observable<any> {
        return this.putRequest(AppUrl.BRANCHES(id), data);
    }

    /*updatePassword(id, data): Observable<any> {
        return this.putRequest(AppUrl.BRANCHES_PASSWORD(id), data);
    }*/

    updateStatus(id, data): Observable<any> {
        return this.putRequest(AppUrl.BRANCHES_STATUS(id), data);
    }

    createByAdmin(id, data): Observable<any> {
        return this.postRequest(AppUrl.UNIVERSITY_BRANCHES(id), data);
    }

    getByAdmin(id, data): Observable<any> {
        return this.getRequest(AppUrl.UNIVERSITY_BRANCHES(id), data);
    }

   /* updateStatus(id, data): Observable<any> {
        return this.putRequest(AppUrl.BRANCHES_STATUS(id), data);
    }*/

    updateByAdmin(universityId, id, data): Observable<any> {
        return this.putRequest(AppUrl.BRANCHES_UPDATE_BY_ADMIN(universityId, id), data);
    }
}
